import React from 'react';
import { useHistory } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import useInView from './useInView';
import reveal from './reveal.module.css';
import styles from './NuestrasEmpresas.module.css';

const empresas = [
  {
    id: 'cordoba',
    nombre: 'BCCY Córdoba',
    descripcion:
      'Unidad de negocio enfocada en el desarrollo y operación de proyectos en la región de Córdoba, con un fuerte compromiso regional.',
    video: '/videos/video-1.mp4', // se usa si existe
    // imagen: '/images/cordoba.jpg', // respaldo si no hay video
    ruta: '/cordoba',
  },
  {
    id: 'holding',
    nombre: 'BCCY Colombia Holding',
    descripcion:'Brazo corporativo que articula la estrategia, las finanzas y el gobierno del grupo, consolidando la visión de largo plazo.',
    video: '/videos/positos1.mp4', 
    // imagen: '/images/holding.jpg', // esta sigue siendo foto
    ruta: '/holding',
  },
];

function NuestrasEmpresas() {
  const history = useHistory();
  const [ref, inView] = useInView(0.15);

  return (
    <section id="nuestras-empresas" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <div
          className={`${styles.header} ${reveal.reveal} ${
            inView ? reveal.visible : ''
          }`}
        >
          <span className={styles.eyebrow}>Nuestras Empresas</span>
          <h2 className={styles.title}>Dos unidades, un mismo propósito</h2>
        </div>

        <div className={styles.grid}>
          {empresas.map((empresa, i) => (
            <article
              key={empresa.id}
              className={`${styles.card} ${reveal.reveal} ${
                inView ? reveal.visible : ''
              }`}
              style={{ transitionDelay: `${0.15 + i * 0.12}s` }}
              onClick={() => history.push(empresa.ruta)}
            >
              <div className={styles.cardImageWrap}>
                {empresa.video ? (
                  <video
                    className={styles.cardImage}
                    src={empresa.video}
                    poster={empresa.imagen}
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                ) : (
                  <img
                    src={empresa.imagen}
                    alt={empresa.nombre}
                    loading="lazy"
                    className={styles.cardImage}
                  />
                )}
              </div>

              <div className={styles.cardBody}>
                <h3 className={styles.cardTitle}>{empresa.nombre}</h3>
                <p className={styles.cardText}>{empresa.descripcion}</p>

                <button
                  type="button"
                  className={styles.cardBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    history.push(empresa.ruta);
                  }}
                >
                  Ingresar <FiArrowRight />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default NuestrasEmpresas;